<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card>
        <h3 class="card-title d-flex">
          <span>Recent Articles</span>
          <a href="" target="_blank" class="ml-2">
            <vs-icon icon="info" size="small" />
          </a>
          <vs-button class="ml-auto" type="filled" icon="add_circle" size="small" @click="addingNewItem">Add New Article</vs-button>
        </h3>
        <vs-row>
          <div style="display: flex; align-items: center; gap: 0.5rem">
            <vs-select :color="colorx" label="Language Filter" v-model="search.language" @change="searchData()" style="width: 25%">
              <vs-select-item :key="index" :value="item.culture" :text="item.culture" v-for="(item, index) in languages" />
            </vs-select>

            <vs-select :color="colorx" label="Status Filter" v-model="search.status" @change="searchData()" style="width: 20%">
              <vs-select-item value text="Select Status" disabled />
              <vs-select-item value="0" text="All" />
              <vs-select-item value="1" text="Active" />
              <vs-select-item value="2" text="Inactive" />
            </vs-select>

            <vs-select :color="colorx" label="Page Limit" v-model="limit" @change="searchData" style="width: 20%">
              <vs-select-item value="25" text="25" />
              <vs-select-item value="50" text="50" />
              <vs-select-item value="100" text="100" />
            </vs-select>

            <vs-button color="warning" type="filled" class="searchBtn" icon="cached" @click="resetData()" style="width: 15%">Reset</vs-button>
          </div>
        </vs-row>
        <br />
        <table class="table">
          <tr>
            <th>#</th>
            <th></th>
            <th>Article Name</th>
            <th>Desc</th>
            <th>Views</th>
            <th>Position</th>
            <th>Language</th>
            <th>Status</th>
            <th>Action</th>
            <th></th>
            <th>Publish Date</th>
          </tr>
          <tr v-for="(item, index) in articleList" :key="item._id">
            <td>{{ index + 1 + (currentPage - 1) * limit }}</td>
            <td>
              <img v-if="item.image == '' || item.image == null" src="../../../assets/images/No-image.png" height="50px" width="75px" />
              <img v-else :src="item.image" height="50px" width="75px" />
            </td>
            <td class="td">
              <div style="display: flex; flex-direction: column">
                <p>
                  {{ item.name }}
                </p>
                Category: {{ item.articlecategory.name }}
              </div>
            </td>
            <td class="td">
              <span class="material-icons" style="cursor: pointer" @click="viewDesc(item)">remove_red_eye</span>
            </td>
            <td class="td">{{ item.totalViewCount }}</td>
            <td class="td">
              <!-- add up and down arrows from react-icons -->
              <div style="display: flex; align-items: center; flex-direction: column; justify-content: center; gap: 0.5rem">
                <!-- <vs-button icon="arrow_upward" size="small" @click="updatePosition(item, search.sort === 'ASC' ? 'up' : 'down')"></vs-button> -->
                {{ item.position }}
                <!-- <vs-button icon="arrow_downward" size="small" @click="updatePosition(item, search.sort === 'ASC' ? 'down' : 'up')"></vs-button> -->
              </div>
            </td>
            <td class="td text-center">
              {{ item.language }}
              <div class="d-flex" v-if="search.language == 'EN' && item.languageCount">
                <div class="progress-bar-container mt-3">
                  <div
                    class="progress-bar p-2"
                    :style="{
                      color: item.languageCount - item.missingLanguages.length === item.languageCount ? 'white' : 'black',
                      backgroundColor: item.missingLanguages.length > 0 ? 'red' : item.missingLanguages.length > 1 ? '#06b800' : '',
                      width: ((item.languageCount - item.missingLanguages.length) / item.languageCount) * 100 + '%',
                    }"
                  >
                    <div class="absoluteText">{{ item.languageCount - item.missingLanguages.length }}/{{ item.languageCount }}</div>
                  </div>
                </div>
                <div class="text-center mt-2 d-flex align-items-center" style="font-weight: 800">
                  <div style="width: 20px; height: 20px; margin-left: 5px" v-popover:tooltip="item.tooltipContent">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="12" y1="16" x2="12" y2="12"></line>
                      <line x1="12" y1="8" x2="12" y2="8"></line>
                    </svg>
                  </div>
                </div>
              </div>
            </td>
            <td class="td">
              <vs-chip v-if="item.status" color="success">Active</vs-chip>
              <vs-chip v-else color="danger">Inactive</vs-chip>
            </td>
            <!-- <td class="td">{{ item.guid }}</td> -->
            <td class="td">
              <vs-checkbox v-model="item.disableForAll" @change="updateStatus(item._id, item.disableForAll)"> Disable All Articles</vs-checkbox>
            </td>
            <td class="td">
              <vs-button class="mr-2 mt-1" icon="create" color="warning" @click="editingItem(item, 'edit')"></vs-button>
              <vs-button
                class="mr-2 mt-1"
                color="danger"
                icon="delete_sweep"
                @click="
                  deleteCategoryPopup = true;
                  itemToDelete = item;
                "
              >
              </vs-button>
            </td>
            <td class="td">
              {{ formatDate(item.publishDate) }}
            </td>
          </tr>
        </table>

        <!-- pagination -->
        <vs-pagination v-model="currentPage" :total="totalPages" :limit="limit" @change="searchData" class="my-4" />

        <!-- Code -->
        <vs-popup :title="isNew ? 'Add New Article' : clone ? 'Duplicate Article' : 'Edit Article'" :active.sync="defaultalert">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="6">
              <vs-select
                :color="colorx"
                label="Article Language*"
                @change="fileterusingLanguage($event, cat)"
                v-model="cat.language"
                icon="arrow_downward"
                :disabled="isNew == true || clone == true"
              >
                <vs-select-item value text="Choose Language" disabled />
                <vs-select-item :value="item.culture" :text="item.culture" v-for="(item, index) in languages" :key="index" />
              </vs-select>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mt-3">
              <vs-input label="Article Name (Keep it Simple and short)*" v-model="cat.name" />
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" v-if="!isNew">
              <p class="mt-2" style="font-size: 0.85rem">Current Position: {{ cat.position }}</p>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" v-if="isNew">
              <p class="mt-2" style="font-size: 0.85rem">Position:</p>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-2">
              <vs-checkbox v-model="cat.moveTop" @change="cat.moveBottom = false">Move to Top</vs-checkbox>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="6" class="mt-2">
              <vs-checkbox v-model="cat.moveBottom" @change="cat.moveTop = false">Move to Bottom</vs-checkbox>
            </vs-col>
            <!-- article desc blocks -->
            <vs-col vs-lg="12" vs-xs="12" class="mt-4" v-if="cat.descriptionBlocks && cat.descriptionBlocks.length > 0">
              <label class="mr-2">Article Description Blocks*: {{ cat.descriptionBlocks && cat.descriptionBlocks.length }}/4</label>
              <span style="font-size: x-small">(Atleast one set of description is required)</span>

              <vs-row v-for="(block, index) in cat.descriptionBlocks" :key="index" class="article-block mb-3">
                <vs-col vs-lg="14" vs-xs="14" style="border: 1px solid #ccc; padding-top: 1rem; padding-bottom: 1rem">
                  <div style="display: flex; justify-content: space-between; align-items: center">
                    <label>Description Block - {{ index + 1 }}</label>
                    <vs-button
                      v-if="cat.descriptionBlocks && cat.descriptionBlocks.length > 1"
                      icon="delete"
                      @click="removeBlock(index)"
                      style="border-radius: 50%; z-index: 0"
                      color="danger"
                    />
                  </div>
                  <div style="display: flex; justify-content: space-between; align-items: center; padding-bottom: 1rem">
                    <!-- ask for native ad/shop item ad -->
                    <vs-select
                      :color="colorx"
                      label="Ad Type"
                      v-model="block.adType"
                      class="mb-2"
                      @change="(block.image = ''), (block.adUrl = ''), (block.shopItem = '')"
                    >
                      <vs-select-item :value="item.value" :text="item.text" v-for="item in adTypes" />
                    </vs-select>
                    <!-- Only show the image upload option when AdOwnImage is selected -->
                    <div class="upload-btn-wrapper vs-input-primary" v-if="block.adType == 'AdOwnImage'" style="width: 50%">
                      <label class="vs-input--label">Ad image</label>
                      <div class="btn mt-2"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                      <input type="file" @change="uploadImageAd($event, index)" />
                    </div>
                    <!-- show shop item selection if its adOwnImage -->
                    <div v-if="block.adType == 'Shop'" style="width: 50%">
                      <label>Shop Item</label>
                      <multiselect
                        v-model="block.shopItem"
                        placeholder="Select Item"
                        label="name"
                        track-by="value"
                        :options="selectedItems"
                        :multiple="false"
                        @input="updateAdDisplayImage(block.shopItem, index)"
                      >
                        <template #singleLabel="{ option }">
                          {{ truncateName(option.name) }}
                        </template>
                      </multiselect>
                    </div>
                  </div>
                  <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 1rem">
                    <vs-col vs-lg="12" vs-xs="12">
                      <!-- remove image -->
                      <vs-button v-if="block.image" color="danger" type="flat" icon="clear" class="closeBtn" @click="block.image = ''"></vs-button>
                      <!-- show image if present -->
                      <img v-if="block.image" :src="block.image" class="imgUp" height="100px" width="150px" />
                    </vs-col>
                    <vs-input
                      label="URL"
                      v-model="block.adUrl"
                      v-if="block.adType == 'AdOwnImage' || block.adType == 'Shop'"
                      :disabled="block.adType == 'Shop'"
                    />
                  </div>
                  <!-- block n -->
                  <vs-col vs-lg="14" vs-xs="14">
                    <label>Description</label>
                    <vue-editor v-model="block.description" :editor-toolbar="customToolbar"></vue-editor>
                  </vs-col>
                </vs-col>
              </vs-row>
              <!-- new block button -->
              <div style="z-index: 0; display: flex; width: 100%; justify-content: end">
                <vs-button class="mt-2" color="primary" @click="addBlock" v-if="cat.descriptionBlocks.length < 4"> + Add Block </vs-button>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12" class="mt-4" v-else>
              <label>Description</label>
              <vue-editor v-model="cat.description"></vue-editor>
            </vs-col>

            <vs-col vs-lg="6" vs-xs="6" class="mt-4">
              <vs-checkbox v-model="cat.status">Status (Active / Inactive)</vs-checkbox>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="displayImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Article Image (Try to use square image)*</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, 1)" />
                  </div>
                </vs-col>
                <vs-col v-if="displayImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage(1)" style="z-index: 0"></vs-button>
                  <img :src="displayImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="fileName">File Name : {{ fileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="12" vs-xs="12">
              <label>Related Articles</label>

              <multiselect
                v-model="cat.relatedArticles"
                placeholder="Select Articles"
                label="name"
                track-by="_id"
                :options="languageArticleList"
                :multiple="true"
                style="z-index: 2"
              ></multiselect>
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <div>
                <vs-col vs-lg="12" vs-xs="12" v-if="notificationImage == ''">
                  <div class="upload-btn-wrapper vs-input-primary">
                    <label class="vs-input--label">Notification File (Try to use square image)</label>
                    <div class="btn"><vs-icon icon="cloud_upload" class="icon-medium"></vs-icon>Upload a File</div>
                    <input type="file" ref="fileInput" @change="uploadImage($event, 2)" />
                  </div>
                </vs-col>
                <vs-col v-if="notificationImage">
                  <vs-button color="danger" type="flat" icon="clear" class="closeBtn" @click="deleteImage(2)"></vs-button>
                  <img :src="notificationImage" class="imgUp" height="100px" width="150px" />
                  <b v-if="notificationfileName">File Name : {{ notificationfileName }}</b>
                </vs-col>
              </div>
            </vs-col>
            <vs-col vs-lg="5" vs-xs="5" class="mt-4">
              <vs-checkbox v-model="cat.notification">Notification (on/off)</vs-checkbox>
            </vs-col>
            <vs-col class="mt-6" vs-lg="6" vs-xs="6">
              <label>Article Publish Date*</label>
              <br />
              <datepicker
                placeholder="Select Date"
                v-model="cat.publishDate"
                format="yyyy-MM-dd"
                input-class="form-group"
                :open-date="new Date()"
              ></datepicker>
            </vs-col>
            <vs-col class="mt-6" vs-lg="6" vs-xs="6">
              <label>Article Publish Time*</label>
              <br />
              <vue-timepicker v-model="cat.publishTime" format="hh:mm A" :minute-interval="15" />
            </vs-col>

            <vs-col vs-lg="12" vs-xs="12" class="mb15 mt20">
              <img v-if="this.$data.cat.authorImage !== ''" :src="cat.authorImage" class="imgUp" height="100px" width="150px" />
              <p class="mt-2">Author: {{ this.$data.cat.authorName || "No Author" }}</p>

              <!-- If author is already assigned -->
              <div v-if="this.$data.cat.authorName && !isNew">
                <vs-button color="danger" @click="clearAuthor">Clear Author</vs-button>
              </div>

              <!-- If no author and !isNew (edit mode) -->
              <div v-if="!isNew && !this.$data.cat.authorName">
                <vs-button @click="assignYourselfAsAuthor">Assign yourself</vs-button>
              </div>
            </vs-col>
            <vs-col vs-lg="9" vs-xs="12">
              <vs-button icon="save" @click="create">{{ isNew ? "Save English" : "Update one" }}</vs-button>
              <!-- hide if article is editing -->
              <vs-button v-if="isNew" class="ml-3" icon="save" @click="createAndTranslate">Save and Translate</vs-button>
              <!-- show only if article is editing and language is english -->
              <vs-button v-if="!showLoader && !isNew && cat.language == 'EN'" class="ml-3" icon="save" @click="createAndTranslate"
                >Update all</vs-button
              >
              <vs-checkbox class="mt-2" v-model="cat.translate" v-if="!isNew && cat.language == 'EN'" style="z-index: 0"
                >Update translations</vs-checkbox
              >
            </vs-col>
          </vs-row>
        </vs-popup>

        <vs-popup class="holamundo" title="Delete Article" :active.sync="deleteCategoryPopup">
          <p>Are you sure you want to delete Article?</p>
          <div>
            <vs-button icon="delete_forever" class="mr15" @click="deleteCategory">Delete Article</vs-button>
            <vs-button icon="clear" @click="deleteCategoryPopup = false">Cancel</vs-button>
          </div>
        </vs-popup>
        <vs-popup title="View Article Description" :active.sync="viewPopup">
          <div v-html="desc"></div>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
    <div v-if="showLoader" class="loader-container">
      <!-- show text that it is working in background. -->
      <div class="loader"></div>
      <vs-col vs-lg="12" vs-xs="1">
        <p class="loader-text">Translations are in progress.</p>
      </vs-col>
    </div>
    <tooltip :width="300" :pointer="true"> </tooltip>
  </vs-row>
</template>

<script>
// import uploader from "../common/uploader.vue";
import api from "@/rest.js";
import { API } from "@/common/constants";
import Multiselect from "vue-multiselect";
import { VueEditor, Quill } from "vue2-editor";
import Datepicker from "vuejs-datepicker";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue2-datepicker/index.css";
import moment from "moment";
import Vue from "vue";
import VPopover from "vue-js-popover";

Vue.use(VPopover, { tooltip: true });

function getFontName(font) {
  return font.toLowerCase().replace(/\s/g, "-");
}

const fontList = ["Onest", "Arial"];
const fontNames = fontList.map((font) => getFontName(font));
const fonts = Quill.import("formats/font");

fonts.whitelist = fontNames;
Quill.register(fonts, true);

let fontStyles = "";
fontList.forEach(function (font) {
  let fontName = getFontName(font);
  fontStyles +=
    ".ql-snow .ql-picker.ql-font .ql-picker-label[data-value=" +
    fontName +
    "]::before, .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=" +
    fontName +
    "]::before {" +
    "content: '" +
    font +
    "';" +
    "font-family: '" +
    font +
    "', sans-serif;" +
    "}" +
    ".ql-font-" +
    fontName +
    "{" +
    " font-family: '" +
    font +
    "', sans-serif;" +
    "}";
});

const node = document.createElement("style");
node.innerHTML = fontStyles;
document.body.appendChild(node);

export default {
  name: "Recent Articles",
  components: {
    // uploader,
    Multiselect,
    VueEditor,
    Datepicker,
    VueTimepicker,
  },
  data: () => ({
    title: "Article",
    colorx: "#0D2144",
    limit: 25,
    currentPage: 1,
    totalPages: 0,
    defaultalert: false,
    deleteCategoryPopup: false,
    viewPopup: false,
    desc: "",
    isNew: true,
    clone: false,
    displayImage: "",
    notificationImage: "",
    fileName: "",
    notificationfileName: "",
    authorImageFileName: "",
    sortDirection: "asc",
    sortByField: "position",
    search: {
      sort: "ASC",
      language: "EN",
      status: "0",
    },
    adTypes: [
      { value: "", text: "none" },
      { value: "Native", text: "Native Ad" },
      { value: "Shop", text: "Shop Ad" },
      { value: "AdOwnImage", text: "Custom Image Ad" },
    ],
    cat: {
      status: true,
      language: "",
      position: "",
      name: "",
      image: "",
      relatedArticles: [],
      notification: true,
      publishDate: "",
      publishTime: null,
      descriptionBlocks: [{ adType: "", description: "", image: "", adUrl: "" }],
      notificationImage: "",
      articlecategory: "",
      // relatedItems: [],
      moveTop: false,
      moveBottom: false,
      authorName: "",
      authorImage: "",
    },
    selectedItems: [],
    itemToDelete: "",
    itemToUpdate: "",
    languages: [],
    articleList: [],
    languageArticleList: [],
    selectedCategory: {},
    enData: {},
    cat2: "",
    showLoader: false,
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      ["bold", "italic", "underline", "strike"],
      [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: [] }],
      ["link", "image", "video"],
      ["clean"],
      [{ font: fonts.whitelist }],
    ],
  }),
  watch: {
    "search.language": function (newLang, oldLang) {
      if (newLang !== oldLang) {
        this.currentPage = 1;
      }
    },
    "search.sort": function (newSort, oldSort) {
      if (newSort !== oldSort) {
        this.currentPage = 1;
      }
    },
    "search.status": function (newStatus, oldStatus) {
      if (newStatus !== oldStatus) {
        this.currentPage = 1;
      }
    },
    limit: function (newLimit, oldLimit) {
      if (newLimit !== oldLimit) {
        this.currentPage = 1;
      }
    },
    "cat.moveTop"(newValue) {
      if (newValue) {
        this.cat.moveBottom = false;
      }
    },
    "cat.moveBottom"(newValue) {
      if (newValue) {
        this.cat.moveTop = false;
      }
    },
  },
  methods: {
    assignYourselfAsAuthor() {
      const user = JSON.parse(localStorage.getItem("user"));
      this.cat.authorName = user.name || "";
      this.cat.authorImage = user.image || "";
      this.$forceUpdate();
    },

    clearAuthor() {
      this.$data.cat.authorName = "";
      this.$data.cat.authorImage = "";
      this.$forceUpdate();
    },

    truncateName(name, length = 15) {
      return name.length > length ? name.substring(0, length) + "..." : name;
    },

    addBlock() {
      if (this.cat.descriptionBlocks.length < 4) {
        this.cat.descriptionBlocks.push({ adType: "", description: "", image: "", adUrl: "" });
      }
    },

    removeBlock(index) {
      if (this.cat.descriptionBlocks.length > 1) {
        this.cat.descriptionBlocks.splice(index, 1);
      }
    },

    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    updateAdDisplayImage(item, index) {
      if (item) {
        this.cat.descriptionBlocks[index].image = item.image;
        this.cat.descriptionBlocks[index].adUrl = item.link;
      }
    },

    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      const user = JSON.parse(localStorage.getItem("user"));
      this.$data.cat = {
        status: true,
        language: "EN",
        position: "",
        name: "",
        image: "",
        relatedArticles: [],
        // relatedItems: [],
        notification: true,
        publishDate: "",
        publishTime: null,
        description: "",
        notificationImage: "",
        articlecategory: this.$data.selectedCategory._id,
        moveBottom: true,
        moveTop: false,
        descriptionBlocks: [{ adType: "", description: "", image: "", adUrl: "", shopItem: "" }],
        authorName: user.name || "",
        authorImage: user.image || "",
      };
      this.$data.displayImage = "";
      this.$data.notificationImage = "";

      // this.fetchArticleList(this.$route.query.catid, "EN");
      this.getPlainData(this.$route.query.catid, "EN");
    },

    async editingItem(i, data) {
      this.$data.cat = JSON.parse(JSON.stringify(i)); 
      this.$data.enData = Object.assign({}, i);
      if (!this.$data.cat.authorImage) this.$data.cat.authorImage = i.authorImage || "";
      if (!this.$data.cat.authorName) this.$data.cat.authorName = i.authorName || "";

      if (typeof this.$data.cat.publishTime === "object") {
        const hours = this.$data.cat.publishTime.hh || "00";
        const minutes = this.$data.cat.publishTime.mm || "00";
        const period = this.$data.cat.publishTime.A || "AM";
        this.$data.cat.publishTime = `${hours}:${minutes} ${period}`;
      } else if (!this.$data.cat.publishTime) {
        this.$data.cat.publishTime = "12:00 AM";
      }

      this.$data.defaultalert = true;
      this.$data.isNew = false;
      this.$data.displayImage = i.image;
      this.$data.notificationImage = i.notificationImage;
      this.$data.clone = data === "clone" ? true : false;
      this.$forceUpdate();
    },

    async create() {
      const missingFields = [];
      if (!this.$data.cat.language) missingFields.push("Language");
      if (!this.$data.cat.name) missingFields.push("Name");
      if (!this.$data.displayImage) missingFields.push("Image");
      if (this.$data.cat.descriptionBlocks) {
        if (!this.$data.cat.descriptionBlocks || !this.$data.cat.descriptionBlocks.length) missingFields.push("Description Blocks");
        if (this.$data.cat.descriptionBlocks[0].description.trim() == "") missingFields.push("1 Description Block");
      }
      if (!this.$data.cat.publishDate) missingFields.push("Publish Date");
      if (!this.$data.cat.publishTime) missingFields.push("Publish Time");

      const publishTime = moment(this.$data.cat.publishTime, "hh:mm A");
      console.log("publishTime", publishTime.minutes(), this.$data.cat.publishTime);
      if (publishTime.minutes() % 15 !== 0) {
        this.$vs.notify({
          text: "Publish Time must be in 15-minute intervals.",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      if (missingFields.length) {
        this.$vs.notify({
          text: `Please enter the following fields: ${missingFields.join(", ")}`,
          color: "danger",
          position: "top-right",
        });
        return;
      }

      try {
        this.$vs.loading();
        var relatedArt = [];
        // var relatedIts = [];
        this.$data.cat.image = this.$data.displayImage;
        this.$data.cat.notificationImage = this.$data.notificationImage;

        if (this.$data.cat.relatedArticles.length > 0) {
          await Promise.all(
            this.$data.cat.relatedArticles.map(async (item) => {
              if (item._id) relatedArt.push(item._id);
            })
          );
        }

        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        if (JSON.parse(localStorage.user).token) headers["x-master-token"] = JSON.parse(localStorage.user).token;

        this.showLoader = true;
        let apiToCall = API.ARTICLE;
        let data = this.$data.cat;

        if (!this.$data.isNew) {
          apiToCall = API.ARTICLE;
          data["image"] = this.$data.displayImage;
          data["notificationImage"] = this.$data.notificationImage;
          data["relatedArticles"] = relatedArt;
          data["descriptionBlocks"] = this.$data.cat.descriptionBlocks;

          const res = await api.put(`${apiToCall}?id=${data._id}`, data, { headers });
          if (res.status === 200) {
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.cat = {
              status: true,
              language: "",
              position: "",
              name: "",
              image: "",
              relatedArticles: [],
              notification: false,
              publishDate: "",
              description: "",
              notificationImage: "",
              moveBottom: true,
              descriptionBlocks: [{ adType: "", description: "", image: "", adUrl: "" }],
              authorName: "",
              authorImage: "",
            };
            await this.searchData();
          }
        } else {
          if (!this.$data.isNew && !this.$data.clone) {
            this.$data.displayImage = "";
            this.$data.notificationImage = "";
          }

          if (!this.$data.cat.moveTop && !this.$data.cat.moveBottom) {
            this.$data.cat.moveBottom = true;
          }
          data["descriptionBlocks"] = this.$data.cat.descriptionBlocks;

          const res = await api.post(apiToCall, data, { headers });
          if (res.status === 200) {
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.cat = {
              status: true,
              language: "",
              position: "",
              name: "",
              image: "",
              relatedArticles: [],
              notification: false,
              publishDate: "",
              description: "",
              notificationImage: "",
              descriptionBlocks: [{ adType: "", description: "", image: "", adUrl: "" }],
              authorName: "",
              authorImage: "",
            };
            await this.searchData();
          }
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          text: "Error Saving",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
        this.showLoader = false;
        this.$data.defaultalert = false;
      }
    },

    async createAndTranslate() {
      const missingFields = [];
      if (!this.$data.cat.language) missingFields.push("Language");
      if (!this.$data.cat.name) missingFields.push("Name");
      if (!this.$data.displayImage) missingFields.push("Image");
      if (this.$data.cat.descriptionBlocks) {
        if (!this.$data.cat.descriptionBlocks || !this.$data.cat.descriptionBlocks.length) missingFields.push("Description Blocks");
        if (this.$data.cat.descriptionBlocks[0].description.trim() == "") missingFields.push("1 Description Block");
      }
      if (!this.$data.cat.publishDate) missingFields.push("Publish Date");
      if (!this.$data.cat.publishTime) missingFields.push("Publish Time");

      const publishTime = moment(this.$data.cat.publishTime, "hh:mm A");
      if (publishTime.minutes() % 15 !== 0) {
        this.$vs.notify({
          text: "Publish Time must be in 15-minute intervals.",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      if (missingFields.length) {
        this.$vs.notify({
          text: `Please enter the following fields: ${missingFields.join(", ")}`,
          color: "danger",
          position: "top-right",
        });
        return;
      }

      try {
        var relatedArt = [];
        // var relatedIts = [];
        this.$data.cat.image = this.$data.displayImage;
        this.$data.cat.notificationImage = this.$data.notificationImage;

        if (this.$data.cat.relatedArticles.length > 0) {
          await Promise.all(
            this.$data.cat.relatedArticles.map(async (item) => {
              if (item._id) relatedArt.push(item._id);
            })
          );
        }

        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };

        if (JSON.parse(localStorage.user).token) headers["x-master-token"] = JSON.parse(localStorage.user).token;

        let apiToCall = API.ARTICLE_CANDT;
        let data = this.$data.cat;
        this.$data.showLoader = true;

        if (!this.$data.isNew && !this.$data.clone) {
          apiToCall = API.UANDT;
          data["image"] = this.$data.displayImage;
          data["notificationImage"] = this.$data.notificationImage;
          data["relatedArticles"] = relatedArt;
          data["descriptionBlocks"] = this.$data.cat.descriptionBlocks;

          this.$data.defaultalert = false;
          this.$data.showLoader = true;

          const res1 = await api.put(apiToCall + "?id=" + data._id, data, { headers });
          if (res1) {
            if (res1.status === 200) {
              this.$data.isNew = true;
              this.$data.itemToUpdate = "";
              this.$data.cat = {
                status: true,
                language: "",
                position: "",
                name: "",
                image: "",
                relatedArticles: [],
                // relatedItems: [],
                notification: false,
                publishDate: "",
                description: "",
                notificationImage: "",
                moveBottom: true,
                descriptionBlocks: [{ adType: "", description: "", image: "", adUrl: "" }],
                authorName: "",
                authorImage: "",
              };
              await this.searchData();
            }
          }
          return;
        }

        if (!this.$data.isNew && !this.$data.clone) {
          this.$data.displayImage = "";
          this.$data.notificationImage = "";
        }

        if (this.$data.clone) {
          apiToCall = API.ARTICLE_CANDT;

          data = {
            name: this.$data.cat.name,
            position: this.$data.cat.position,
            language: this.$data.cat.language,
            status: this.$data.cat.status,
            image: this.$data.cat.image,
            description: this.$data.cat.description,
            publishDate: this.$data.cat.publishDate,
            publishTime: this.$data.cat.publishTime,
            notification: this.$data.cat.notification,
            relatedArticles: relatedArt,
            notificationImage: this.$data.cat.notificationImage,
            articlecategory: this.$data.selectedCategory._id,
            authorName: this.$data.cat.authorName,
            authorImage: this.$data.cat.authorImage,
          };
          data["descriptionBlocks"] = this.$data.cat.descriptionBlocks;
        }

        this.$data.defaultalert = false;
        this.$data.showLoader = true;

        const res2 = await api.post(apiToCall, data, { headers });
        if (res2) {
          if (res2.status === 200) {
            this.$data.isNew = true;
            this.$data.itemToUpdate = "";
            this.$data.cat = {
              status: true,
              language: "",
              position: "",
              name: "",
              image: "",
              relatedArticles: [],
              // relatedItems: [],
              notification: false,
              publishDate: "",
              description: "",
              notificationImage: "",
              descriptionBlocks: [{ adType: "", description: "", image: "", adUrl: "" }],
              authorName: "",
              authorImage: "",
            };
            await this.searchData();
          }
        }
      } catch (error) {
        console.log(error);
        this.$vs.notify({
          text: "Error Saving",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
        this.$data.showLoader = false;
        this.$data.defaultalert = false;
        this.$vs.notify({
          text: "Saved Successfully",
          color: "success",
          position: "top-right",
        });
      }
    },

    fetchSingleCategory(id) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      this.$vs.loading();
      api
        .get(`${API.ARTICLE_CATEGORY}/single/${id}`, {
          headers,
        })

        .then((r) => {
          this.$vs.loading.close();
          this.$data.selectedCategory = r.data.data;
          // if (!r.data.status) {
          //   this.$vs.notify({
          //     title: "Error",
          //     text: r.data.error,
          //     color: "danger",
          //     position: "top-right",
          //   });
          // }
        })
        .catch(() => {});
    },
    async fetchArticleList(id, language = null) {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };
      var APIENDPOINT = API.ARTICLE;
      const languages = this.$data.search.language;

      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }
      this.$vs.loading();

      const res = await api.get(
        `${APIENDPOINT}?articlecategory=${id}&language=${languages}&sort=${this.$data.search.sort}&status=${this.$data.search.status}`,
        { headers }
      );

      if (this.isNew) {
        const res = await api.get(`${APIENDPOINT}?language=EN&sort=${this.$data.search.sort}&status=${this.$data.search.status}`, { headers });
        console.log("here");

        this.$data.languageArticleList = res.data.data;
      }

      if (res.status === 200 && res.data.data.length > 0) {
        this.$vs.loading.close();

        for (const item of res.data.data) {
          item.tooltipContent =
            item.missingLanguages.length > 0 ? "Missing Languages: " + item.missingLanguages.join(", ") : "All Languages are translated";
        }

        this.$data.articleList = res.data.data;
        this.$data.selectedCategory.name = res.data.data[0].articlecategory.name;
        // if (!r.data.status) {
        //   this.$vs.notify({
        //     title: "Error",
        //     text: r.data.error,
        //     color: "danger",
        //     position: "top-right",
        //   });
        // }
      } else {
        this.$vs.loading.close();
        // this.$vs.notify({
        //   title: "Error",
        //   text: 'Error fetching article list',
        //   color: "danger",
        //   position: "top-right",
        // });
      }
    },

    fetchAffiliateItems() {
      this.$vs.loading();
      // api.get("https://shop.exaweb.in:5200/affiliate/allItems")
      api
        .get("https://api.exaweb.in:5200/affiliate/allItems")
        .then((response) => {
          this.$vs.loading.close();
          this.$data.selectedItems = response.data.map((item) => ({
            name: item.title,
            value: item._id,
            image: item.images[0],
            link: item.link,
          }));
        })
        .catch((error) => {
          console.error("Error fetching affiliate items:", error);
          this.$vs.loading.close();
        });
    },

    deleteCategory() {
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }
      api
        .delete(API.ARTICLE + "?id=" + this.$data.itemToDelete._id, {}, { headers })

        .then((r) => {
          if (r.status) {
            this.$data.deleteCategoryPopup = false;
            this.searchData();
            this.$vs.notify({
              text: "Deleted Successfully",
              color: "success",
              position: "top-right",
            });
          }
        })
        .catch(() => {});
    },
    fetchAllLanguages() {
      this.$vs.loading();
      api
        .get(API.GET_LANG, {})
        .then((r) => {
          this.$vs.loading.close();
          this.$data.languages = r.data;
        })
        .catch(() => {});
    },

    async searchData() {
      this.$vs.loading();

      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["token"] = this.$data.token;
      }

      try {
        const page = !isNaN(this.currentPage) && this.currentPage > 0 ? this.currentPage : 1;

        const res = await api.get(
          `${API.ARTICLES_RECENTS}?language=${this.$data.search.language}&sort=${this.$data.search.sort}&status=${this.$data.search.status}&page=${page}&limit=${this.limit}`,
          { headers }
        );

        if (res.status === 200 && res.data.data && res.data.data.length > 0) {
          this.$data.articleList = res.data.data;

          this.totalPages = Math.ceil(res.data.totalNumber / this.limit);

          this.$data.cat2 = res.data.data[0].articlecategory._id;
          this.$data.selectedCategory.name = res.data.data[0].articlecategory.name;
        } else this.$data.articleList = [];
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        this.$vs.loading.close();
      }
    },

    async uploadImageAd(data, flag) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();

      formdata.append("adType", this.$data.cat.descriptionBlocks[flag].adType);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      try {
        const res = await api.post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        if (res.status == 200) {
          this.$data.cat.descriptionBlocks[flag].image = res.data.files[0].url;
          this.$vs.notify({
            text: "File Uploaded",
            color: "success",
            position: "top-right",
          });
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        this.$vs.notify({
          text: "File Uploading Failed",
          color: "danger",
          position: "top-right",
        });
      }
    },
    uploadImage(data, flag) {
      const imageType = ["image/jpeg", "image/jpg", "image/webp"];
      var isValid = false;
      isValid = imageType.indexOf(data.target.files[0].type) > -1;

      if (!isValid) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "Only JPEG,JPG,WEBP Image files formats should be supported",
          color: "danger",
          position: "top-right",
        });
        this.$refs.fileInput.value = null;
        return;
      }
      if (data.target.files[0].size > 500000) {
        this.$vs.notify({
          title: "Uploading Error",
          text: "File size should be less than 500kb",
          color: "danger",
          position: "top-right",
        });
        return;
      }

      let formdata = new FormData();
      if (flag === 1) {
        this.$data.fileName = data.target.files[0].name;
      } else if (flag === 2) {
        this.$data.notificationfileName = data.target.files[0].name;
      } else {
        this.$data.authorImageFileName = data.target.files[0].name;
      }

      formdata.append("category", this.$data.cat.name);
      formdata.append("file", data.target.files[0]);
      this.$vs.loading();
      api
        .post(API.UPLOAD_IMAGE, formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.error != null) {
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Uploading Error",
              text: response.data.error.message,
              color: "danger",
              position: "top-right",
            });
          } else {
            const data = response;
            if (flag === 1) {
              this.$data.displayImage = response.data.files[0].url;
            } else if (flag === 2) {
              this.$data.notificationImage = response.data.files[0].url;
            } else {
              this.$data.cat.authorImage = response.data.files[0].url;
            }

            if (response) {
              this.$vs.notify({
                text: "File Uploaded",
                color: "success",
                position: "top-right",
              });
              this.$vs.loading.close();
            } else {
              this.$vs.loading.close();
              this.$vs.notify({
                text: "File Uploading Failed",
                color: "danger",
                position: "top-right",
              });
            }
            this.$refs.fileInput.value = null;
            this.$emit("input", data);
          }
        })
        .catch(() => {});
      this.$vs.loading.close();
    },
    deleteImage(flag) {
      if (flag == 1) {
        this.$data.displayImage = "";
      } else if (flag == 2) {
        this.$data.notificationImage = "";
      } else {
        this.$data.cat.authorImage = "";
      }
    },
    resetData() {
      this.$data.search = {
        sort: "ASC",
        language: "EN",
        status: "0",
      };
      this.$data.limit = 25;
      this.$data.currentPage = 1;
      this.searchData();
    },

    async getPlainData(cat, lang) {
      try {
        let headers = {
          "Content-Type": "application/json;charset=utf-8",
        };
        if (JSON.parse(localStorage.user).token) {
          headers["token"] = this.$data.token;
        }

        const relatedList = await api.get(`${API.ARTICLE}/plain?language=${lang}&sort=${this.$data.search.sort}&status=${this.$data.search.status}`, {
          headers,
        });

        if (relatedList.status == 200) {
          this.$data.languageArticleList = relatedList.data.data;
        } else {
          this.$data.languageArticleList = [];
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },

    async fileterusingLanguage(event, item) {
      try {
        // if (event == "EN") {
        //   return;
        // }
        let id = item.ref || item._id;
        if (event && id) {
          let headers = {
            "Content-Type": "application/json;charset=utf-8",
          };
          if (JSON.parse(localStorage.user).token) {
            headers["token"] = this.$data.token;
          }
          this.$vs.loading();
          const res = await api.get(API.ARTICLE + "/sin/" + id, { headers, params: { language: event } });
          if (res.status == 200) {
            const artCat = res.data.data.articlecategory._id;
            this.getPlainData(artCat, event);

            this.$data.cat = Object.assign({}, res.data.data);
            // console.log(res.data.data)
            this.$data.displayImage = res.data.data.image;
            this.$data.notificationImage = res.data.data.notificationImage;
            // this.fetchArticleList(artCat, event);
            this.searchData();
            this.$vs.loading.close();
          } else {
            this.$data.cat = Object.assign({}, this.$data.enData);
            this.$vs.loading.close();
          }
        }
      } catch (error) {
        this.$data.cat = Object.assign({}, this.$data.enData);
        console.error("Error try again.:", error);
        this.$vs.notify({
          title: "Error",
          text: "Error try again.",
          color: "danger",
          position: "top-right",
        });
        this.$vs.loading.close();
      }
    },
    copyGuid(guid) {
      var input_temp = document.createElement("input");
      input_temp.value = guid;
      document.body.appendChild(input_temp);
      input_temp.select();
      document.execCommand("copy");
      document.body.removeChild(input_temp);
      this.$vs.notify({
        text: "GUID copied",
        color: "success",
        position: "top-right",
      });
    },
    viewDesc(item) {
      this.$data.viewPopup = true;
      if (item.descriptionBlocks) {
        this.$data.desc = item.descriptionBlocks
          .map((block, index) => {
            // if(block.adType === "Shop" || block.adType === "AdOwnImage") {
            //   return `<div>Ad:${block.adType}</div><img src="${block.image}" style="width: 100px; height: 100px;"/><div><div><b>Ad Url:</b> ${block.adUrl}</div><br/><b>Desc Block:${index+1}</b> ${block.description}</div>`;
            // } else {
            //   return `<div>Ad:${block.adType}</div><div><b>Desc Block:${index+1}</b> ${block.description}</div>`;
            // }
            return `<div>${block.description}</div>`;
          })
          .join("<br>");
      } else {
        this.$data.desc = item.description;
      }
    },
    updateStatus(id, data) {
      // console.warn(id);
      // console.warn(data);

      // this.$data.disableCategoryPopup = true;
      let headers = {
        "Content-Type": "application/json;charset=utf-8",
      };

      if (JSON.parse(localStorage.user).token) {
        headers["x-master-token"] = JSON.parse(localStorage.user).token;
      }

      api
        .put(API.ARTICLE + "/disable" + "?id=" + id, { status: data }, { headers })
        .then((r) => {
          this.$vs.loading.close();
          // this.fetchArticleList(this.$route.query.catid);
          this.searchData();
        })
        .catch(() => {
          this.$vs.loading.close();
        });
    },
  },
  created() {
    if (this.$data.search.language) {
      this.$data.search.language = this.$route.query.catLang;
    }

    this.fetchAllLanguages();
    this.fetchAffiliateItems();

    if (!this.$data.search.language) {
      this.$data.search.language = "EN";
    }
  },
  mounted() {
    this.searchData();
    // this.fetchAffiliateItems();
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Be+Vietnam+Pro:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Onest:wght@100..900&display=swap");

.loader-container {
  background-color: gray;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1rem;
  padding-right: 1rem;
  padding-left: 1rem;
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
}

.loader {
  border: 2px solid white;
  border-top: 2px solid red;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

.loader-text {
  color: white;
  text-align: center;
  font-size: 1.2rem;
  margin-top: 10px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}

.mt20 {
  margin-top: 20px;
}

.searchBtn {
  margin-top: 25px;
  margin-right: 5px;
  width: 30%;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  width: 100%;
  cursor: pointer !important;
}

.btn {
  border: 1px solid rgba(0, 0, 0, 0.2);
  background-color: white;
  padding: 0.4rem;
  border-radius: 0px;
  font-size: 0.85rem;
  width: 100%;
  cursor: pointer;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.progress-bar-container {
  width: 100%;
  background-color: #f3f3f3;
  border: 1px rgba(0, 0, 0, 0.068) solid;
  border-radius: 20px;
  overflow: hidden;
  margin-bottom: 5px;
}

.progress-bar {
  height: 10px;
  transition: width 0.3s ease;
}

.absoluteText {
  text-align: start;
}
</style>
